// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hidden-container--I6uYO.invisible--K7xnA{display:none}.hidden-container--I6uYO.inherit-height--EcgF0{height:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden-container": "hidden-container--I6uYO",
	"invisible": "invisible--K7xnA",
	"inherit-height": "inherit-height--EcgF0"
};
export default ___CSS_LOADER_EXPORT___;
